import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import fileDownload from 'js-file-download';
import store from '@/state/store';
import { affiliateAPI, playersModuleAPI } from '@samclick-static-urls';
import { sendGet, sendPut, sendPost } from '@samclick-api-client';
import Payload from './payload';
import { multipleReplace } from '@/utils/common-utils';


class PlayersState {
    public loading: boolean = false

    public players: object[] = []
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'players',
})
class PlayersStore extends VuexModule {
    playersStore: PlayersState = new PlayersState();

  @Mutation
    PLAYERS_REINITIALIZE() {
        this.playersStore = new PlayersState();
    }

  @Mutation
  SET_PLAYERS_LOADING(loading: boolean) {
      this.playersStore.loading = loading;
  }

  @Mutation
  SET_PLAYER_REPORT(data: object[]) {
      this.playersStore.players = data || [];
  }

  @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_PLAYERS_LOADING', show);
  }

  @Action({ rawError: true })
  destroyPlayers() {
      this.context.commit('PLAYERS_REINITIALIZE');
  }

  @Action({ rawError: true })
  getPlayerSales(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(playersModuleAPI.getSales, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_PLAYER_REPORT', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  exportPlayerReports(payload: Payload = new Payload()) {
      this.showLoader(false);
      return new Promise((resolve, reject) => {
          sendGet(playersModuleAPI.exportPlayerSales, payload.data).then((response) => {
              fileDownload(response.data, 'report-file.csv');
              resolve(response);
          }, (error) => {
              reject(error.response);
          });
      });
  }
}


export default getModule(PlayersStore);
